import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';

import { HomePageRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';

import { HomeApiService } from './api/home.api.service';
import { CarouselHomePageModule } from '../common/carousel/carousel-home/carousel-home.module';
import { DownloadAppPageModule } from '../common/download-app/download-app.module';
import { AstrologyCardPageModule } from '../common/astrology-card/astrology-card.module';
import { CarouselCardPageModule } from '../common/carousel-card/carousel-card.module';
import { SearchHomePageModule } from '../common/search/search-home/search-home.module';
import { HomeEnquirySidepanelComponent } from './enquiry-sidepanel/sidepanel.component';
import { TestimonialComponent } from './testimonial/gallery-home.component';
import { SharedLazyModule } from 'src/app/shared-lazy.module';
import { CoreModule } from 'src/app/core/core.module';


@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedLazyModule,
    MatIconModule,
    MatInputModule,
    MatRippleModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,

    HomePageRoutingModule,
    CarouselHomePageModule,
    DownloadAppPageModule,
    AstrologyCardPageModule,
    CarouselCardPageModule,
    SearchHomePageModule
  ],
  declarations: [
    HomeComponent,
    TestimonialComponent,
    HomeEnquirySidepanelComponent
  ],
  providers: [HomeApiService]
})
export class HomePageModule { }
